import React from 'react';
import MainLayout from './components/MainLayout';

const App = () => {
  return <MainLayout />;
};

export default App;